"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Image = _ref => {
  let {
    className,
    alt,
    size,
    fallback,
    rounded,
    src,
    imageReference,
    fullWidth,
    renderAs,
    getAssetUrl,
    imageSize,
    caption,
    alignment,
    children,
    ...props
  } = _ref;
  const [imageSrc, setImageSrc] = (0, _react.useState)(getAssetUrl(src || imageReference));
  (0, _react.useEffect)(() => {
    setImageSrc(getAssetUrl(src || imageReference));
  }, [src]);
  let s = size;
  if (typeof size === 'number') {
    s = `${s}x${s}`;
  }
  const RenderAs = renderAs;
  const classNames = {
    [`is-${s}`]: s,
    'is-fullwidth': fullWidth
  };
  const imageClassNames = (0, _classnames.default)({
    'is-rounded': rounded
  });
  const imageElement = /*#__PURE__*/_react.default.createElement(RenderAs, _extends({}, props, {
    className: (0, _classnames.default)('image', className, classNames)
  }), children && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children), !children && /*#__PURE__*/_react.default.createElement("img", {
    className: imageClassNames,
    onError: () => {
      if (fallback && imageSrc !== fallback) {
        setImageSrc({
          fallback
        });
      }
    },
    src: imageSrc,
    width: imageSize === 'medium' ? 336 : undefined,
    alt: alt
  }), renderAs === 'figure' && caption && /*#__PURE__*/_react.default.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(caption, {
        USE_PROFILES: {
          html: true
        }
      })
    }
  }));
  if (alignment === 'center') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "is-fullwidth has-text-centered"
    }, imageElement);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageElement);
};
Image.propTypes = {
  className: _propTypes.default.string,
  src: _propTypes.default.string,
  imageReference: _propTypes.default.string,
  alt: _propTypes.default.string.isRequired,
  rounded: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf([16, 24, 32, 48, 64, 96, 128, 'square', '1by1', '4by3', '3by2', '16by9', '2by1', '5by4', '5by3', '3by1', '4by5', '3by4', '2by3', '3by5', '9by16', '1by2', '1by3']), _propTypes.default.number, _propTypes.default.string]),
  alignment: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center']), _propTypes.default.string]),
  getAssetUrl: _propTypes.default.func,
  imageSize: _propTypes.default.oneOfType([_propTypes.default.oneOf(['medium']), _propTypes.default.string]),
  fallback: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  caption: _propTypes.default.string,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
Image.defaultProps = {
  renderAs: 'figure',
  getAssetUrl: url => url
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Image);
//# sourceMappingURL=Image.js.map